import React from 'react';
import PropTypes from 'prop-types';
import { ImageMosaic, ImageMosaicDto, MosaicWall } from '@ami/react/core';
import { Alert } from 'reactstrap';
import InclusiveMosaicLeadTime from './InclusiveMosaicLeadTime';
import { quoteProductType } from '../otherQuoteEntities';

const ProductCategorySelectionComponent = ({
  contact,
  attachmentPoint,
  productCategories,
  productCategoryId,
  onChange,
  title,
  selectedQuoteProductType
}) => {
  const mapped = productCategories.map(
    (x) => {
      return new ImageMosaicDto({
        id: x.id,
        label: x.name,
        imageUrl: x.imageUrl,
        selected: x.id === productCategoryId,
        extraInformation:
          x.lowestLeadTimeByAttachmentPoint && attachmentPoint ? (
            <InclusiveMosaicLeadTime
              leadTime={x.lowestLeadTimeByAttachmentPoint[attachmentPoint.id]}
            />
          ) : null,
      });
    }
  );
  return (
    <div className="row my-4">
      <MosaicWall
        title={selectedQuoteProductType === quoteProductType.allProducts ? '' : (title || 'Add Product')}
        childrenContainerClassName="row"
      >
        {mapped.map((x) => (
          <ImageMosaic
            key={x.id}
            data={x}
            onClick={() => onChange(x.id)}
            customClassName={x.extraInformation ? 'hasBestLeadTime' : ''}
          />
        ))}
      </MosaicWall>
      <div className="justify-content-center">
        {mapped.length === 0 &&
          attachmentPoint &&
          attachmentPoint.couplerDecision && (
            <Alert
              color="warning"
              className="text-center text-lg text-black"
              style={{ margin: '0 auto' }}
            >
              {contact && (
                <div>
                  Attachments are available, please contact {contact.fullName}{' '}
                  for details and pricing
                  <div className="d-flex justify-content-center">
                    <strong>Email:&nbsp;&nbsp;</strong>
                    <a href={'mailto:' + contact.email}>{contact.email}</a>
                  </div>
                </div>
              )}
              {!contact && (
                <span>
                  Attachments are available, please contact AMI for details and
                  pricing
                </span>
              )}
            </Alert>
          )}
        {mapped.length === 0 &&
          attachmentPoint &&
          !attachmentPoint.couplerDecision && (
            <Alert
              color="warning"
              className="text-center"
              style={{ margin: '0 auto' }}
            >
              <i className="fa fa-exclamation-circle fa-lg text-danger" /> To
              configure attachments, you must make a lugging selection on the
              previous step
            </Alert>
          )}
        {mapped.length === 0 &&
          attachmentPoint &&
          !attachmentPoint.couplerDecision && (
            <Alert
              color="warning"
              className="text-center"
              style={{ margin: '0 auto' }}
            >
              <i className="fa fa-exclamation-circle fa-lg text-danger" /> To
              configure attachments, you must make a lugging selection on the
              previous step
            </Alert>
          )}
      </div>
    </div>
  );
};

ProductCategorySelectionComponent.propTypes = {
  contact: PropTypes.instanceOf(Object),
  attachmentPoint: PropTypes.instanceOf(Object),
  onChange: PropTypes.func.isRequired,
  productCategoryId: PropTypes.string,
  productCategories: PropTypes.arrayOf(Object),
  title: PropTypes.string,
};

export { ProductCategorySelectionComponent };
